import { useCallback } from 'react';
import { useOverlayContext } from 'seagull';
import { useLocaleKeys } from '~/i18n';
import { isDuplicateNameError } from '~/utils/api/isDuplicateNameError';
import { useCreateCustomPageTemplateTestIds } from './useCreateCustomPageTemplate';
import { useUpdateCustomPageTemplateTestIds } from './useUpdateCustomPageTemplate';
export function useTemplateSaveErrorHandler(param) {
    let { mode, setNameError } = param;
    const { t } = useLocaleKeys();
    const { showErrorToast } = useOverlayContext();
    return useCallback((error)=>{
        if (isDuplicateNameError(error)) {
            setNameError(t.customPages.templates.duplicateNameMessage());
            return;
        }
        const genericMessage = mode === 'create' ? t.customPages.templates.createError() : t.customPages.templates.updateError();
        const toastTestId = mode === 'create' ? useCreateCustomPageTemplateTestIds.ErrorToast() : useUpdateCustomPageTemplateTestIds.ErrorToast();
        showErrorToast(genericMessage, toastTestId);
    }, [
        mode,
        setNameError,
        showErrorToast,
        t
    ]);
}
